<template>
  <div style="width:100%;min-height:100vh;background:#0f0f0f;padding-bottom:60px;">
    <van-nav-bar
      style="position:fixed;top:0;left:0;width:100%;background:#1a1a1a;"
      title="每日视频"
      left-arrow
      @click-left="$router.back()"
    />
    <div style="height:46px;"></div>

    <div v-if="loading" style="text-align:center;padding:60px 0;color:#fff;">
      <van-loading color="#cf866b" size="40px" />
      <div style="margin-top:15px;color:#999;">加载中...</div>
    </div>

    <div v-else-if="videolist.length === 0" style="text-align:center;padding:80px 20px;color:#666;">
      <div style="font-size:50px;">🎬</div>
      <div style="margin-top:15px;font-size:0.4rem;">今日暂无视频，请稍后再来</div>
    </div>

    <div v-else>
      <!-- 播放窗口 -->
      <div style="width:100%;background:#000;position:relative;">
        <!-- 未点击时显示封面占位 -->
        <div v-if="!playing" @click="startPlay"
          style="width:100%;height:56vw;background:#111;display:flex;align-items:center;justify-content:center;cursor:pointer;">
          <div style="text-align:center;">
            <div style="font-size:60px;">▶</div>
            <div style="color:#cf866b;font-size:0.36rem;margin-top:8px;">点击播放</div>
          </div>
        </div>
        <!-- 点击后才渲染video标签 -->
        <video
          v-if="playing"
          ref="mainVideo"
          :src="currentSrc"
          controls
          autoplay
          controlsList="nodownload" preload="metadata" playsinline webkit-playsinline preload="metadata" x5-video-player-type="h5" x5-video-player-fullscreen="true" webkit-playsinline playsinline
          style="width:100%;max-height:56vw;display:block;background:#000;"
          @ended="playNext"
        ></video>
        <div style="padding:10px 15px;background:#1a1a1a;">
          <div style="color:#fff;font-size:0.42rem;font-weight:700;">{{ current.title || '视频' + (currentIndex+1) }}</div>
          <div style="color:#999;font-size:0.32rem;margin-top:4px;">{{ currentIndex+1 }} / {{ videolist.length }}</div>
        </div>
      </div>

      <!-- 播放列表 -->
      <div style="padding:10px;">
        <div style="color:#cf866b;font-size:0.36rem;font-weight:700;padding:8px 5px 10px;">播放列表</div>
        <div
          v-for="(item, index) in videolist"
          :key="item.id"
          @click="switchVideo(index)"
          :style="{
            display:'flex',
            alignItems:'center',
            padding:'12px 10px',
            marginBottom:'8px',
            borderRadius:'10px',
            background: currentIndex===index ? '#2a1f1a' : '#1a1a1a',
            border: currentIndex===index ? '1px solid #cf866b' : '1px solid #2a2a2a',
            cursor:'pointer'
          }"
        >
          <div style="width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;"
            :style="{background: currentIndex===index ? '#cf866b' : '#333'}">
            <span v-if="currentIndex===index" style="color:#fff;font-size:18px;">▶</span>
            <span v-else style="color:#999;font-size:0.32rem;">{{ index+1 }}</span>
          </div>
          <div style="margin-left:12px;flex:1;overflow:hidden;">
            <div style="color:#fff;font-size:0.38rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
              :style="{color: currentIndex===index ? '#cf866b' : '#fff'}">
              {{ item.title || '视频' + (index+1) }}
            </div>
            <div style="color:#666;font-size:0.28rem;margin-top:3px;">
              {{ formatSize(item.file_size) }}
              <span v-if="cachedUrls[item.url]" style="color:#52c41a;margin-left:6px;">✓ 已缓存</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video-page',
  data() {
    return {
      loading: true,
      videolist: [],
      currentIndex: 0,
      playing: false,
      currentSrc: '',
      cachedUrls: {},
    };
  },
  computed: {
    current() {
      return this.videolist[this.currentIndex] || {};
    }
  },
  created() {
    this.getVideoList();
  },
  methods: {
    getVideoList() {
      let that = this;
      that.loading = true;
      that.$apiFun.get('/api/video/today', {}).then(res => {
        that.loading = false;
        if (res.code === 200) {
          that.videolist = res.data;
        }
      }).catch(() => {
        that.loading = false;
      });
    },
    startPlay() {
      this.playing = true;
      this.currentSrc = this.current.url;
      this.cachedUrls[this.current.url] = true;
    },
    switchVideo(index) {
      this.currentIndex = index;
      const url = this.videolist[index].url;
      if (!this.playing) {
        this.playing = true;
      }
      this.$nextTick(() => {
        if (this.$refs.mainVideo) {
          if (this.currentSrc === url) {
            // 同一个视频不重新load
            this.$refs.mainVideo.play();
          } else {
            this.currentSrc = url;
            this.cachedUrls[url] = true;
            this.$refs.mainVideo.load();
            this.$refs.mainVideo.play();
          }
        } else {
          this.currentSrc = url;
          this.cachedUrls[url] = true;
        }
      });
    },
    playNext() {
      if (this.currentIndex < this.videolist.length - 1) {
        this.switchVideo(this.currentIndex + 1);
      }
    },
    formatSize(bytes) {
      if (!bytes) return '';
      if (bytes > 1024 * 1024 * 1024) return (bytes / 1024 / 1024 / 1024).toFixed(1) + 'GB';
      if (bytes > 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + 'MB';
      return (bytes / 1024).toFixed(1) + 'KB';
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/video.vue